import Routes from 'components/RoutesWithErrorElement'
import Section from 'components/UI/Section'
import { Route } from 'react-router-dom'
import Home from './components/Home'
import SkillTypes from './components/SkillTypes'
import SubFamily from './components/SubFamily'
import Graph from './Graph'
import Header from './Header'
import { HeaderProvider } from './Header/context'
import './styles.scss'

function Matrix() {
  return (
    <HeaderProvider>
      <Section className="matrix">
        <Header />
        <Routes>
          <Route index element={<Home />} />
          <Route path="subfamily" element={<SubFamily />} />
          <Route path="skilltypes" element={<SkillTypes />} />
          <Route path="graph" element={<Graph />} />
        </Routes>
      </Section>
    </HeaderProvider>
  )
}

export default Matrix
